export const environment = {
  appVersion: 'Version 1.5.1+20240109',
  appName: 'DMS DT V2',
  production: true,
  apiURL: 'https://dms-dt.hanumanbeverages.com.kh/dms/',
  apiLink: 'https://dms-dt.hanumanbeverages.com.kh/',
  apiUrlIAM: 'https://dms-dt.hanumanbeverages.com.kh/iam/v1/',
  apiEncryption: {
    enabled: true,
  },
  storageEncryption: {
    enabled: true,
  },
  keycloak: {
    authority: 'https://login.hanuman.com.kh/realms/hanuman',
    clientId: 'hb-ui-dms-depo',
    scope: 'openid profile email organization:hb',
    redirectUri: '/sessions/callback',
    postLogoutRedirectUri: '/',
    enableSsoCheck: true,
    enableSilentSso: true,
    enableIframeSessionChecks: false,
    refreshTokenExpiryWarningSeconds: 30,
  },
};
